export const APP_CONSTANTS = {
  APP_NAME: 'MORPh',
  CLARITY_ID: 'kkevlbi33k',
};